import { CustomStringParam, SchemaFilterType } from '@ui/src';

export const columns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'aggregationType',
    label: 'Aggregation type',
    sortable: true,
  },
  {
    name: 'totalAmount',
    label: 'Amount (CAD)',
  },
  {
    name: 'status',
    label: 'Status',
    sortable: true,
  },
  {
    name: 'periodStart',
    label: 'Created at',
    sortable: true,
  },
  {
    name: 'deadlineAt',
    label: 'Deadline',
    sortable: false,
  },
  {
    name: 'values',
    label: '',
    hidden: true,
  },
];

export const expandableColumns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'transferDate',
    label: 'Transfer Date',
  },
  {
    name: 'currencyId',
    label: 'Currency',
  },
  {
    name: 'sum',
    label: 'Amount',
  },
  {
    name: 'convertedAmount',
    label: 'Amount (CAD)',
  },
  {
    name: 'beneficiaryAccountNumber',
    label: 'Beneficiary',
  },
];

export const columnsLabels = {};

export const schema = {
  status: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
};

export const filtersSchema = [];
